import { atom } from "recoil";
import { SelectedAsset } from "../../AssetOverview";

export const selectedAssetsForTagsAtom = atom<SelectedAsset[] | undefined>({
  key: "selectedAssetsForTagsAtom",
  default: undefined,
});
